<!--
   Created by qing on 2022/6/11 上午11:21
   Des:
-->
<template>

  <van-popup
    class="link-form-detail-popup"
    v-model="visible"
    :style="{ width: '100%', height:'90%' }"
    get-container="body"
    position="bottom">

    <FormViewDataDetail
      :key="instanceId"
      ref="formViewDataDetail"
      :viewType="1"
      :appId="appId"
      :formId="formId"
      :isLink="Boolean(isLink)"
      :needBack="false"
      @saveDataComplete="saveFormDataComplete"
      @deleteComplete="deleteComplete">
    </FormViewDataDetail>
  </van-popup>
</template>

<script>
  import FormViewDataDetail from "../component/FormViewDataDetail"
  export default {
    name: "FormViewDataPopup",
    components: {
      FormViewDataDetail
    },
    props: {
      viewType: {
        type: Number,
        default: 3
      },
      appId: {
        type: String,
        default: ''
      },
      formId: {
        type: String,
        default: ''
      },
      // 是否是外链
      isLink: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible: false,
        instanceId: ''
      }
    },
    created() {
    },
    methods: {
      open ({
              instanceId,
              index,
              dataList,
              viewId,
              stepId = "",
              isShowLog,
              isDynamic,
              showApply,
              showComment,
              readonlyFields = [],
              readonlyAll = false,
              showFields = [],
              canEdit
            }) {

        this.instanceId = instanceId
        this.visible = true

        const loading = this.$toast.loading()
        setTimeout(() => {
          if (this.$refs.formViewDataDetail) {
            this.$refs.formViewDataDetail.open({
              instanceId,
              stepId,
              viewId,
              showFields,
              index,
              dataList,
              canEdit,
              isShowLog,
              isDynamic,
              showApply,
              showComment,
              readonlyFields,
              readonlyAll
            })
          }
          loading.clear()
        }, 1000)
      },

      saveFormDataComplete() {
        this.visible = false
        this.$emit('saveFormDataComplete')
      },
      deleteComplete() {
        this.visible = false
        this.$emit('deleteComplete')
      }
    },
  }
</script>

<style lang="less">

</style>